"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faArrowUpRightFromSquare = void 0;
var faArrowUpRightFromSquare = {
  prefix: 'fal',
  iconName: 'faArrowUpRightFromSquare',
  icon: [512, 512, [], '', 'M400 288C391.2 288 384 295.2 384 304V448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V160c0-17.67 14.33-32 32-32h112C184.8 128 192 120.8 192 112S184.8 96 176 96L64 96c-35.35 0-64 28.65-64 64V448c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64V304C416 295.2 408.8 288 400 288zM496 0h-160C327.2 0 320 7.156 320 16S327.2 32 336 32h121.4L180.7 308.7c-6.25 6.25-6.25 16.38 0 22.62C183.8 334.4 187.9 336 192 336s8.188-1.562 11.31-4.688L480 54.63V176C480 184.8 487.2 192 496 192S512 184.8 512 176v-160C512 7.156 504.8 0 496 0z']
};
exports.faArrowUpRightFromSquare = faArrowUpRightFromSquare;